// eslint-disable-next-line import/prefer-default-export
export const VIEW_MODE = {
  GRID: '/grid',
  LIST: '/list',
  TABLE: '/table',
};
